module.exports = __webpack_public_path__ + "img/6.413461b0.svg";